<div class="network-container" #networkContainer>
  <!-- Resume Cards -->
  <div class="resume-card card-1" style="top: 20%; left: 70%;">
    <div class="header"></div>
    <div class="name">John Doe</div>
    <div class="title">Software Engineer</div>
    <div class="section"></div>
    <div class="section-title">Experience</div>
    <div class="content-line">
      <div class="bullet"></div>
      <div class="line line-1"></div>
    </div>
    <div class="content-line">
      <div class="bullet"></div>
      <div class="line line-2"></div>
    </div>
    <div class="content-line">
      <div class="bullet"></div>
      <div class="line line-3"></div>
    </div>
    <div class="section">
      <div class="section-title">Skills</div>
      <div class="content-line">
        <div class="bullet"></div>
        <div class="line line-4"></div>
      </div>
      <div class="content-line">
        <div class="bullet"></div>
        <div class="line line-5"></div>
      </div>
    </div>
  </div>

  <div class="resume-card card-2" style="top: 60%; left: 20%;">
    <div class="header">
      <div class="name">Jane Smith</div>
      <div class="title">Product Manager</div>
    </div>
    <div class="section"></div>
    <div class="section-title">Experience</div>
    <div class="content-line">
      <div class="bullet"></div>
      <div class="line line-1"></div>
    </div>
    <div class="content-line">
      <div class="bullet"></div>
      <div class="line line-2"></div>
    </div>
    <div class="content-line">
      <div class="bullet"></div>
      <div class="line line-3"></div>
    </div>
    <div class="section">
      <div class="section-title">Skills</div>
      <div class="content-line">
        <div class="bullet"></div>
        <div class="line line-4"></div>
      </div>
      <div class="content-line">
        <div class="bullet"></div>
        <div class="line line-5"></div>
      </div>
    </div>
  </div>

  <div class="resume-card card-3" style="top: 40%; left: 50%;">
    <div class="header">
      <div class="name">Mike Johnson</div>
      <div class="title">UX Designer</div>
    </div>
    <div class="section">
      <div class="section-title">Experience</div>
      <div class="content-line">
        <div class="bullet"></div>
        <div class="line line-1"></div>
      </div>
      <div class="content-line">
        <div class="bullet"></div>
        <div class="line line-2"></div>
      </div>
      <div class="content-line">
        <div class="bullet"></div>
        <div class="line line-3"></div>
      </div>
    </div>
    <div class="section">
      <div class="section-title">Skills</div>
      <div class="content-line">
        <div class="bullet"></div>
        <div class="line line-4"></div>
      </div>
      <div class="content-line">
        <div class="bullet"></div>
        <div class="line line-5"></div>
      </div>
    </div>
  </div>
</div>
